export const PREFIX = 'EHR_APPOINTMENTS';

export const LIST_EHR_APPOINTMENTS = `${PREFIX}/LIST`;
export const CLEAR_EHR_APPOINTMENTS = `${PREFIX}/CLEAR`;
export const TOGGLE_EHR_APPOINTMENT_DISCLOSURE = `${PREFIX}/TOGGLE_DISCLOSURE`;
